import type { HelpFile } from '../../types/help'
import { ScriptExecuteLogPageTestIds } from '../../../testids/ScriptExecuteLogPageTestIds'

export const scriptExecuteLogPageHelp: HelpFile = {
  docPage: '/docs/admin/script-execute-log',
  texts: {
    [ScriptExecuteLogPageTestIds.scriptExecuteLogPage]:
      'Forensic audit trail of every sql.execute() call (DDL) run from scripts — both preview dry-runs and real runtime executions. PostgreSQL audit triggers do not fire on DDL, so this log is the only record of CREATE/DROP/ALTER/TRUNCATE operations.',
    [ScriptExecuteLogPageTestIds.scriptExecuteLogFilters]: null,
    [ScriptExecuteLogPageTestIds.filterActor]:
      'Filter to a single user who ran the SQL. Both preview and runtime rows record the acting user.',
    [ScriptExecuteLogPageTestIds.filterMode]:
      'Filter by execution mode. `Preview` is a `Try SQL` dry-run that was rolled back; `Runtime` is a real execution inside a scheduled job run.',
    [ScriptExecuteLogPageTestIds.filterSuccess]:
      'Filter by outcome — show only successful or only failed executions.',
    [ScriptExecuteLogPageTestIds.filterOccurredFrom]:
      'Show only executions at or after this time.',
    [ScriptExecuteLogPageTestIds.filterOccurredTo]:
      'Show only executions at or before this time.',
    [ScriptExecuteLogPageTestIds.clearFilters]: null,
    [ScriptExecuteLogPageTestIds.colOccurredAt]:
      'When the SQL execution started (server time).',
    [ScriptExecuteLogPageTestIds.colMode]:
      '`Preview` (rolled-back dry-run) or `Runtime` (real execution inside a job).',
    [ScriptExecuteLogPageTestIds.colActor]:
      'The user who ran the SQL. Denormalized — preserved even if the user is later deleted.',
    [ScriptExecuteLogPageTestIds.colSqlText]:
      'The raw SQL that was executed, truncated here — open the row for the full text. Avoid embedding secrets as literals; they are stored verbatim.',
    [ScriptExecuteLogPageTestIds.colDurationMs]:
      'Wall-clock time of the SQL execution in milliseconds (the JDBC call only — excludes network and serialization).',
    [ScriptExecuteLogPageTestIds.colSuccess]:
      'Whether the execution completed without error.',
    [ScriptExecuteLogPageTestIds.colErrorCode]:
      'For failed executions, the error category code (e.g. `SQL_PREVIEW_LIMIT_EXCEEDED`). Empty for successful rows.',
    [ScriptExecuteLogPageTestIds.modePreview]: null,
    [ScriptExecuteLogPageTestIds.modeRuntime]: null,
    [ScriptExecuteLogPageTestIds.successTrue]: null,
    [ScriptExecuteLogPageTestIds.successFalse]: null,
    [ScriptExecuteLogPageTestIds.scriptExecuteLogDetail]:
      'Full detail for a single execution — the complete SQL text and, for failures, the error message.',
    [ScriptExecuteLogPageTestIds.detailSqlText]:
      'The complete SQL statement that was executed, untruncated.',
    [ScriptExecuteLogPageTestIds.detailErrorMessage]:
      'The error message for a failed execution. Empty for successful rows.',
    [ScriptExecuteLogPageTestIds.detailClose]: null,
  },
}
